module.exports = __webpack_public_path__ + "img/btn.5fc3ff54.png";